import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { postRequest } from '../../helpers/apiHandler';
import { useSelector } from 'react-redux'

const AdminDeleteModal = ({ show, onClose, setAlertState, data, refreshData }) => {
  const { access_token } = useSelector((state) => state.auth.user)

  const deleteAdmin = () => {
    postRequest(`/admin/admin-delete/`, { id: data.id, email: data.email }, access_token.token, (res) => {
      if (res.success) {
        refreshData()
        onClose()
        setAlertState({
          message: 'Admin Deleted',
          show: true,
          variant: 'success',
        });
      } else {
        setAlertState({
          message: res.message || 'There was an issue while deleting admin',
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Admin</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to delete <strong>{data.name}</strong>?
          <br />
          This action cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button
          variant={'danger'}
          onClick={deleteAdmin}
        >
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdminDeleteModal;
